import React, { useState } from 'react';

import { FlexRow } from '@editor/components/utilities/layouts';
import { Button, secondarySmallTheme } from '@repo/ui/components/Buttons';
import { IconEventWrapper } from '@repo/ui/components/Icon';
import CloseIcon from '@repo/ui/components/Icon/CloseIcon';
import GiftIcon from '@repo/ui/components/Icon/GiftIcon';
import { themeStyle } from '@repo/ui/theming';

import TextInput from '../TextInput/TextInput';

import { AppliedPromoCode, AppliedPromoCodeWrapper, Clickable } from './styles';
import { PromoCodeProps } from './types';

const PromoCode: React.FC<PromoCodeProps> = (props) => {
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState<'initial' | 'applied'>(
    props?.initialValue ? 'applied' : 'initial'
  );
  const [inputCode, setInputCode] = useState('');
  const [appliedPromoCode, setAppliedPromoCode] = useState<string | null>(
    props?.initialValue ?? null
  );

  const handleClick = async (): Promise<void> => {
    if (isLoading) {
      return;
    }

    if (!inputCode.length) {
      setError('Enter a promo code.');
      return;
    }

    setIsLoading(true);

    const result = await props.onApplyClick(inputCode);

    if (!result.success) {
      setError(result.error);
    } else {
      setState('applied');
      setAppliedPromoCode(inputCode);
    }

    setIsLoading(false);
  };

  const handleRemoveClick = async (): Promise<void> => {
    props.onRemoveClick();

    setState('initial');
    setInputCode('');
    setAppliedPromoCode(null);
  };

  const handleChange = (value: string): void => {
    setError(null);
    setInputCode(value);
  };

  if (state === 'applied') {
    return (
      <AppliedPromoCodeWrapper>
        <GiftIcon height="16px" />
        <AppliedPromoCode>{appliedPromoCode}</AppliedPromoCode>
        <Clickable disabled={props.disabled} onClick={handleRemoveClick}>
          <IconEventWrapper
            disabled={props.disabled}
            theme={{ activeColor: themeStyle.varInkMain }}
          >
            <CloseIcon
              height="10px"
              theme={{ color: themeStyle.varInkMedium }}
            />
          </IconEventWrapper>
        </Clickable>
      </AppliedPromoCodeWrapper>
    );
  }

  const textInputTheme = {
    height: '30px',
    width: '60%',
  };

  const applyButtonTheme = {
    ...secondarySmallTheme,
    width: '40%',
  };

  return (
    <FlexRow gap="12px">
      <TextInput
        blurOnEnter
        disabled={isLoading || props.disabled}
        error={error ?? undefined}
        placeholder="Add Promo Code"
        theme={textInputTheme}
        value={inputCode}
        onChanging={handleChange}
        onEnter={handleClick}
      />
      <Button
        disabled={!!error || props.disabled || !inputCode.length}
        label="Apply"
        loading={isLoading}
        name="applyPromoCodeButton"
        theme={applyButtonTheme}
        onClick={handleClick}
      />
    </FlexRow>
  );
};

export default PromoCode;
